import algoliasearch from 'algoliasearch/lite';

const algoliaInfo = {
    searchClient: algoliasearch(
        process.env.GATSBY_ALGOLIA_APP_ID,
        process.env.GATSBY_ALGOLIA_SEARCH_KEY
    ),
    HITS_PER_PAGE: 16,
};

export default algoliaInfo;